import styled from 'vue-styled-components'

export default styled.div`
    & .response-error {
        display: flex;
        background-color: #efefef;        
        padding: 15px;
        max-height: 300px;
        overflow: auto;
        border: 1px solid #cccccc;
        border-radius: 5px;
    }
    & .error-title {
        display: block;
        margin-top: 15px;
        margin-bottom: 10px;
    }
`;